import React from 'react';
import styles from './LegalGuardianInformations.module.sass';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import PhoneInput from '../../../components/PhoneInput';


const LegalGuardianInformations = ({ student, onStudentChange }) => {
    return (
        <Card className={styles.card} title="Informations du représentant légal" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Nom du représentant"
                    name="legal_guardian_last_name"
                    type="text"
                    placeholder="Nom"
                    value={student?.legal_guardian_last_name || ''}
                    onChange={onStudentChange}
                />
                <TextInput
                    className={styles.field}
                    label="Prénom du représentant"
                    name="legal_guardian_first_name"
                    type="text"
                    placeholder="Prénom"
                    value={student?.legal_guardian_first_name || ''}
                    onChange={onStudentChange}
                />
                <TextInput
                    className={styles.field}
                    label="Email du représentant"
                    name="legal_guardian_email"
                    type="email"
                    placeholder="email@example.com"
                    value={student?.legal_guardian_email || ''}
                    onChange={onStudentChange}
                />
                <PhoneInput
                    className={styles.field}
                    label="Numéro de téléphone"
                    name="legal_guardian_phone"
                    id="legal_guardian_phone"
                    placeholder="+33 6 XX XX XX XX"
                    value={student?.legal_guardian_phone || ''}
                    onChange={onStudentChange}
                    autoComplete="tel"
                />
            </div>
        </Card>
    );
};

export default LegalGuardianInformations;